import { globalActions } from '../../global-actions';

export const getActionTypes = (actionPrefix) => ({
  SHOW_BANNER_BOTTOM: `${actionPrefix}_SHOW_BANNER_BOTTOM`,
  HIDE_BANNER_BOTTOM: `${actionPrefix}_HIDE_BANNER_BOTTOM`,
});

export const getActions = (actionPrefix) => ({
  showBannerBottom: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).SHOW_BANNER_BOTTOM,
    });
  },
  hideBannerBottom: () => {
    globalActions.next({
      type: getActionTypes(actionPrefix).HIDE_BANNER_BOTTOM,
    });
  },
});
